import React, { useState, useEffect } from "react";
import { Button, Form, FloatingLabel, Card, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import { getUserSession } from "../component/userInfo";

const TitleImageForm = () => {
  const [id, setId] = useState(null);
  const [title, setTitle] = useState("");
  const [releaseDate, setReleaseDate] = useState("");
  const [filekey, setFilekey] = useState(
    (Math.floor(Math.random() * 1000000) + 1000000 + "").substring(1)
  );

  const [items, setItems] = useState({
    TITLEIMG01: {
      file: null,
      url: "",
      path: "",
      css: "",
      label: "이미지1(교회소개)",
    },
    TITLEIMG02: {
      file: null,
      url: "",
      path: "",
      css: "",
      label: "이미지2(설교영상)",
    },
    TITLEIMG03: {
      file: null,
      url: "",
      path: "",
      css: "",
      label: "이미지3(사귐의소식)",
    },
    TITLEIMG04: {
      file: null,
      url: "",
      path: "",
      css: "",
      label: "이미지4(다음세대)",
    },
  });

  const location = useLocation();
  const navigate = useNavigate();

  const previewStyle = {
    width: "100%",
    height: "100px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: ".25rem",
    border: "1px solid #dee2e6",
    cursor: "pointer",
  };

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (query.id) {
      fetchImageInfo(query.id);
    }
  }, [location]);

  const fetchImageInfo = async (id) => {
    const formData = new FormData();
    formData.append("action", "read");
    formData.append("id", id);

    try {
      const res = await fetch(
        "https://work.wekoinonia.org/json/titleImage.php",
        { method: "POST", body: formData }
      );
      const json = await res.json();
      if (json.code === "0000") {
        setId(json.id);
        setTitle(json.title);
        setReleaseDate(
          json.release_date ? json.release_date.replace(" ", "T") : ""
        );

        setItems((prevItems) => {
          const newItems = { ...prevItems };
          if (json.items) {
            for (const kind in json.items) {
              if (newItems[kind]) {
                newItems[kind].path = json.items[kind].image_path;
                newItems[kind].css = json.items[kind].css;
              }
            }
          }
          return newItems;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleImageChange = (e, kind) => {
    const file = e.target.files[0];
    if (file) {
      setItems((prev) => ({
        ...prev,
        [kind]: { ...prev[kind], file: file, url: URL.createObjectURL(file) },
      }));
    }
  };

  const handleCssChange = (e, kind) => {
    const css = e.target.value;
    setItems((prev) => ({
      ...prev,
      [kind]: { ...prev[kind], css: css },
    }));
  };

  const uploadImages = async () => {
    const userSession = getUserSession();

    for (const kind in items) {
      const item = items[kind];
      if (item.file) {
        const formData = new FormData();
        formData.append("file", item.file);
        formData.append("fieldName", "file");
        formData.append("path", "main_title_image");
        formData.append("uid", userSession.uid);
        formData.append("filekey", filekey);
        formData.append("parentTable", "main_title_image");
        formData.append("kind", kind);

        try {
          const res = await fetch(
            "https://work.wekoinonia.org/json/imageUpload.php",
            { method: "POST", body: formData }
          );
          const result = await res.json();
          if (result.code !== "0000") {
            throw new Error(`(${item.label}) ${result.msg}`);
          }
        } catch (e) {
          console.error(e);
          alert(`${item.label} 이미지 업로드 실패: ${e.message}`);
          return false; // Stop on first error
        }
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userSession = getUserSession();

    const uploadSuccess = await uploadImages();

    if (!uploadSuccess) {
      return; // Stop if image upload failed
    }

    const formData = new FormData();
    formData.append("action", "save");
    if (id) formData.append("id", id);
    formData.append("title", title);
    formData.append("release_date", releaseDate);
    formData.append("uid", userSession.uid);
    formData.append("filekey", filekey);

    let i = 1;
    for (const kind in items) {
      formData.append(`css${i}`, items[kind].css);
      i++;
    }

    try {
      const res = await fetch(
        "https://work.wekoinonia.org/json/titleImage.php",
        { method: "POST", body: formData }
      );
      const json = await res.json();
      if (json.code === "0000") {
        alert("저장되었습니다.");
        navigate("/TitleImageList");
      } else {
        alert("저장 실패: " + json.msg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="container">
      <h1>타이틀 이미지 {id ? "수정" : "등록"}</h1>
      <Form onSubmit={handleSubmit}>
        <FloatingLabel controlId="title" label="제목" className="mb-3">
          <Form.Control
            type="text"
            placeholder="제목"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </FloatingLabel>
        <FloatingLabel
          controlId="releaseDate"
          label="공개일시"
          className="mb-3"
        >
          <Form.Control
            type="datetime-local"
            placeholder="공개일시"
            value={releaseDate}
            onChange={(e) => setReleaseDate(e.target.value)}
          />
        </FloatingLabel>

        <p className="text-muted mb-3">
          image size " 기존 값이 (2560w * 350h)로 구성되어 있었습니다.
          해당이미지는 백그라운드 속성으로 나타납니다."
        </p>

        <Row>
          {Object.keys(items).map((kind) => {
            const item = items[kind];
            return (
              <Col md={6} key={kind} className="mb-4">
                <Card>
                  <Card.Header>{item.label}</Card.Header>
                  <Card.Body>
                    <Form.Group className="mb-3">
                      <Form.Control
                        type="file"
                        onChange={(e) => handleImageChange(e, kind)}
                        accept="image/*"
                      />
                    </Form.Group>
                    <FloatingLabel
                      controlId={`css-${kind}`}
                      label="CSS"
                      className="mb-3"
                    >
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="background-position: 62%; height: 21.875rem;"
                        value={item.css}
                        onChange={(e) => handleCssChange(e, kind)}
                      />
                    </FloatingLabel>

                    {item.path && !item.url && (
                      <div className="mt-3">
                        <Card.Text>현재 이미지</Card.Text>
                        <div
                          style={{
                            ...previewStyle,
                            backgroundImage: `url(https://work.wekoinonia.org/${item.path})`,
                          }}
                          onClick={() =>
                            window.open(
                              `https://work.wekoinonia.org/${item.path}`,
                              "_blank"
                            )
                          }
                          title="클릭하여 전체 이미지 보기"
                        ></div>
                      </div>
                    )}
                    {item.url && (
                      <div className="mt-3">
                        <Card.Text>새 이미지</Card.Text>
                        <div
                          style={{
                            ...previewStyle,
                            backgroundImage: `url(${item.url})`,
                          }}
                          onClick={() => window.open(item.url, "_blank")}
                          title="클릭하여 전체 이미지 보기"
                        ></div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>

        <div className="text-center">
          <Button
            variant="secondary"
            onClick={() => navigate("/TitleImageList")}
            className="me-2"
          >
            목록
          </Button>
          <Button variant="primary" type="submit">
            저장
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default TitleImageForm;
